import api from "../../api/api";
import { cloneDeep } from 'lodash';
import { retrieveInventoryRoom, getInventoryRooms, getInventoryList, fetchInventoryRooms, } from './cases';

import { history } from "../../../history";
import * as routePaths from "../../constants/routePaths";

import { batch } from 'react-redux';
import Validation from "../../common/Validation";
import { CurrentState } from "../../common/currentState";

export const GET_RETRIEVEINVENTORY = 'GET_RETRIEVEINVENTORY';
export const GET_RETRIEVEROOMTYPES = 'GET_RETRIEVEROOMTYPES';
export const GET_HOUSEHOLDITEMTYPES = 'GET_HOUSEHOLDITEMTYPES';
export const GET_RETRIEVEVEHICLETYPES = 'GET_RETRIEVEVEHICLETYPES';
export const GET_CURRENTROOM = 'GET_CURRENTROOM';
export const SET_PRINT_INVENTORY = 'SET_PRINT_INVENTORY';
export const INITIALIZE_PRINT_INVENTORY = 'INITIALIZE_PRINT_INVENTORY';
export const SET_VEHICLE_INVENTORY = 'SET_VEHICLE_INVENTORY';
export const GET_ENGINE_TYPE = 'GET_ENGINE_TYPE';
export const INITIALIZE_INVENTORY_ITEMS = 'INITIALIZE_INVENTORY_ITEMS';
export const SET_INVENTORY_ITEM = 'SET_INVENTORY_ITEM';
export const UPDATING_INVENTORY = 'UPDATING_INVENTORY';

export function getRetrieveInventory(inventoryDetails) {
    return {
        type: GET_RETRIEVEINVENTORY,
        inventoryDetails: inventoryDetails
    }
}

export function getRetrieveRoomTypes(roomTypes) {
    return {
        type: GET_RETRIEVEROOMTYPES,
        roomTypes: roomTypes
    }
}

export function getHouseholdItemTypes(householdItemTypes) {
    return {
        type: GET_HOUSEHOLDITEMTYPES,
        householdItemTypes: householdItemTypes
    }
}

export function getRetrieveVehicleTypes(vehicleTypes) {
    return {
        type: GET_RETRIEVEVEHICLETYPES,
        vehicleTypes: vehicleTypes
    }
}

export function getCurrentRoom(currentRoom) {
    return {
        type: GET_CURRENTROOM,
        currentRoom: currentRoom
    }
}

// used for initializing an empty array to store all the custom items edition
export function initializeInventoryItem(itemsSorted) {
    return {
        type: INITIALIZE_INVENTORY_ITEMS,
        items: itemsSorted,
    }
}

export function initializePrintInventory(length) {
    return {
        type: INITIALIZE_PRINT_INVENTORY,
        length: length,
    }
}

export function setCustomItem(index, dataSet) {
    return {
        type: SET_INVENTORY_ITEM,
        index: index,
        dataSet: dataSet,
    }
}

export function setPrintInventory(index, isEmpty) {
    return {
        type: SET_PRINT_INVENTORY,
        index: index,
        isEmpty: isEmpty,
    }
}

export function setVehicleInventory(isEmpty) {
    return {
        type: SET_VEHICLE_INVENTORY,
        isEmpty: isEmpty,
    }
}

export function getEngineType(engineTypes) {
    return {
        type: GET_ENGINE_TYPE,
        engineTypes: engineTypes,
    }
}

export function updatingInventory(updating) {
    return {
        type: UPDATING_INVENTORY,
        updating: updating,
    }
}

// called to retrieve updated inventory room
export function retrieveUpdatedInventoryRoom(inventoryId, roomId, isRoomVehicle) {
    return (dispatch) => {
        // retrive the current inventory
        return dispatch(retrieveInventoryRoom(inventoryId, roomId, isRoomVehicle))
            // get currentRoom from retrieveInventoryRoom, then update the current room
            .then(currentRoom => {
                dispatch(getCurrentRoom(currentRoom))
                return currentRoom;
            })
            .catch(err => err)
    }
}

// is called as item is added into the room
// then update corresponding inventory room
export function updateInventoryRoom(inventoryId, roomId, inventoryRoom, isRoomVehicle) {
    const url = `api/InventoryDetailService/UpdateInventoryRoom`;
    return dispatch => {
        return api.request(url, 'post', inventoryRoom).then(response => {
            if (response.Successful) {
                dispatch(retrieveUpdatedInventoryRoom(inventoryId, response.InventoryRoom.InventoryRoomID, isRoomVehicle))
            }
            return response.Successful
        })
    }
}

export function updateInventoryRoomWaitForFetch(inventoryId, roomId, inventoryRoom, isRoomVehicle) {
    const url = `api/InventoryDetailService/UpdateInventoryRoom`;
    return dispatch => {
        return api.request(url, 'post', inventoryRoom).then(response => {
            if (response.Successful) {
                return dispatch(retrieveUpdatedInventoryRoom(inventoryId, response.InventoryRoom.InventoryRoomID, isRoomVehicle))
            }
        })
    }
}

export function createInventory(inventoryData) {
    const url = `/api/Inventory`;
    return (dispatch, getState) => {
        return api.request(url, 'post', inventoryData)
            .then(response => {
                const { InventoryData } = inventoryData;
                const { Name } = InventoryData
                const createdInventoryId = response.Id;
                if (response.Successful) {
                    batch(() => {
                        // update inventoryList
                        const createdInventory = {
                            constID: createdInventoryId,
                            Name: Name,
                            Amount: 0,
                            Volume: 0,
                            InventoryID: createdInventoryId
                        }
                        const updatedInvList = [...getState().cases.get('inventoryList')];
                        updatedInvList.push(createdInventory);
                        dispatch(getInventoryList(updatedInvList));
                        // update inventoryRooms
                        const updatedInvRooms = { ...getState().cases.get('inventoryRooms') };
                        fetchInventoryRooms(createdInventoryId)
                            .then(inventoryRooms => {
                                updatedInvRooms[createdInventoryId] = inventoryRooms;
                                dispatch(getInventoryRooms(updatedInvRooms));
                                history.push(routePaths.INVENTORY + '/' + createdInventoryId);
                            })
                        // update inventoryDetails
                        const updatedInvDetails = { ...getState().inventory.get('inventoryDetails') };
                        retrieveInventoryDetails(createdInventoryId)
                            .then(invDetail => {
                                updatedInvDetails[createdInventoryId] = invDetail;
                                dispatch(getRetrieveInventory(updatedInvDetails));
                            })
                    });
                }
                return response.Successful;
            })
    }
}

// called after inventory is edited
export function updateEditInventory(inventoryData, inventoryList, inventoryDetails) {
    // need to update cases -> inventoryList
    // need to update inventory -> inventoryDetails

    const url = `/api/Inventory`;
    return dispatch => {
        return api.request(url, 'post', inventoryData)
            .then(response => {
                const { InventoryID, Name } = inventoryData.InventoryData;
                if (response.Successful) {
                    // update the content in inventoryList
                    const updatedInventoryList = [...inventoryList];
                    const updatedInventoryInListIndex = updatedInventoryList.findIndex(list => list.InventoryID === InventoryID);
                    const updatedInventory = { ...updatedInventoryList[updatedInventoryInListIndex] };
                    updatedInventory.Name = Name;
                    updatedInventoryList[updatedInventoryInListIndex] = updatedInventory;
                    const updatedInvDetails = { ...inventoryDetails };
                    retrieveInventoryDetails(InventoryID)
                        .then(retrievedInventoryDetails => {
                            updatedInvDetails[InventoryID] = retrievedInventoryDetails;
                        })
                        .then(() => {
                            batch(() => {
                                dispatch(getInventoryList(updatedInventoryList));
                                dispatch(getRetrieveInventory(updatedInvDetails));
                                history.push(routePaths.INVENTORY + '/' + InventoryID);
                            });
                        })
                }
                return response.Successful;
            })
    }
}

// get individual inventory details
export function retrieveInventoryDetails(id) {
    const url = '/api/InventoryDetailService/RetrieveInventoryDetails';
    const inventoryId = { "id": id };
    return api.request(url, 'post', inventoryId)
        .then(response => {
            return response.InventoryDetails;
        })
}

// match inventoryDetails and inventoryList
// need to be optimized as stringfyInventory is never same as stringfyExistedInventory
// may not be useful as can be replaced anyway
export function fetchInventoryList(inventoryList, inventoryDetails) {
    return (dispatch, getState) => {
        // check if the inventory in the inventory details matches to inventory list
        inventoryList.forEach(async inventory => {
            const inventoryId = inventory.constID;
            const existedInventory = inventoryDetails[inventoryId];
            const stringfyInventory = JSON.stringify(inventory);
            const stringfyExistedInventory = JSON.stringify(existedInventory);
            // if exited inventory does not matches, then fetch the item
            if (stringfyInventory !== stringfyExistedInventory) {
                return retrieveInventoryDetails(inventoryId)
                    .then(inventoryDetails => {
                        const prevDetails = getState().inventory.get('inventoryDetails');
                        let updatedInventoryDetails = { ...prevDetails };
                        updatedInventoryDetails[inventoryId] = inventoryDetails;
                        dispatch(getRetrieveInventory(updatedInventoryDetails));
                        return inventoryDetails;
                    })

            }
        });
    }
}

export function createInventoryRoom(inventoryID, roomTypeID, customRoomName, vehicleTypeId) {
    const url = '/api/InventoryDetailService/CreateInventoryRoom';
    const content = {
        InventoryPartyDetail: {
            InventoryId: inventoryID,
            PartyId: sessionStorage.getItem('transfereeId'),
            RoomTypeId: roomTypeID,
            CustomRoomName: customRoomName,
            VehicleTypeId: vehicleTypeId
        }
    }

    return (dispatch, getState) => {
        return api.request(url, 'post', content)
            .then(response => {
                if (response.Successful) {
                    // get copy of all inventory
                    const allInventory = { ...getState().cases.get('inventoryRooms') };
                    // update the updated inventory
                    const updatedInventory = [...allInventory[inventoryID]];
                    updatedInventory.push(response.InventoryRoom);
                    allInventory[inventoryID] = updatedInventory;
                    dispatch(getInventoryRooms(allInventory));
                }
                return response;
            })
    }
}

export function deleteInventoryRoom(inventoryID, roomId) {
    const url = '/api/Inventory/InventoryRoom/' + roomId;
    return (dispatch, getState) => {
        return api.request(url, 'delete', null)
            .then(response => {
                if (response.Successful) {
                    // get copy of all inventory
                    const allInventory = { ...getState().cases.get('inventoryRooms') };
                    // update the updated inventory
                    let updatedInventory = [...allInventory[inventoryID]];
                    // filter out selected room
                    updatedInventory = updatedInventory.filter(room => {
                        return room.InventoryRoomID !== roomId
                    });
                    allInventory[inventoryID] = updatedInventory;
                    dispatch(getInventoryRooms(allInventory));
                }
                return response.Successful;
            })
    }
}

export function deleteInventory(inventoryId) {
    const url = 'api/Inventory/' + inventoryId;
    return (dispatch, getState) => {
        return api.request(url, 'delete', null)
            .then(response => {
                if (response.Successful) {
                    // update inventoryList
                    let updatedInvList = [...getState().cases.get('inventoryList')];
                    // get copy of all inventory in inventoryRooms
                    updatedInvList = updatedInvList.filter(inventoryList => inventoryList.InventoryID !== inventoryId);
                    const updatedInvRooms = { ...getState().cases.get('inventoryRooms') };
                    delete updatedInvRooms[inventoryId];
                    // update the updated inventory
                    const updatedInvDetails = { ...getState().inventory.get('inventoryDetails') };
                    delete updatedInvDetails[inventoryId];

                    batch(() => {
                        dispatch(getRetrieveInventory(updatedInvDetails));
                        dispatch(getInventoryRooms(updatedInvRooms));
                        dispatch(getInventoryList(updatedInvList));
                        history.push(routePaths.INVENTORY);
                    });

                    return response.Successful;
                }
                return response.Successful;
            })
    }
}

export function deletePartyAsset(inventoryId, roomId, partyAssetID) {
    const url = '/api/InventoryDetailService/DeletePartyAsset';
    const deleteQuery = {
        PartyAssetId: partyAssetID,
        InventoryRoomId: roomId,
        InventoryId: inventoryId,
    }

    return api.request(url, 'delete', deleteQuery).then(response => {
        return response.Successful
    });
}

export function retrieveVehicleEngineTypes(inventory) {
    const url = 'api/ReferenceDataService/RetrieveVehicleEngineTypes';
    return dispatch => {
        if (inventory.engineTypes.length === 0) {
            return api.request(url, 'get')
                .then(response => {
                    dispatch(getEngineType(response.ReferenceDataCollection));
                    return response.ReferenceDataCollection;
                })
        }
    }
}

// check all the inputs from item table
export async function validateAllInputs(customItems) {
    const updatedCustomItems = cloneDeep(customItems);
    let validInputs = true;
    updatedCustomItems.forEach(item => {
        const { HouseholdPersonalProperties } = item;
        HouseholdPersonalProperties.modified = true;
        const { Quantity, Amount } = HouseholdPersonalProperties;
        const quantity = parseInt(Quantity) === 0;
        const amount = parseInt(Amount) === 0;
        if (quantity && amount);
        else {
            let validItem = true;
            // only when quantity & amount is a positive value
            validItem = validItem && Quantity > 0;
            validItem = validItem && Amount > 0;
            // quantity is valid digits, 
            validItem = validItem && Validation.allNumeric(Quantity);
            // and value is valid value
            validItem = validItem && Validation.validInteger(Amount);
            // then it's valid submit
            validInputs = validInputs && validItem;
        }
    });
    return {
        validInputs: validInputs,
        updatedCustomItems: updatedCustomItems,
    };
    // return (dispatch, getState) => {
    //     // const updatedCustomItems = cloneDeep(customItems);

    //     dispatch(initializeInventoryItem(updatedCustomItems));
    //     if (validInputs) {
    //         dispatch(updatingInventory(true));
    //         dispatch(saveAllItems(updatedCustomItems))
    //     } else {
    //         dispatch(updatingInventory(false));
    //     }

    // }
}

export async function saveAllItems(updatedCustomItems) {
    return (dispatch, getState) => {
        const inventoryRoom = {
            InventoryID: updatedCustomItems.InventoryID,
            Name: updatedCustomItems.Name,
            InventoryRoomID: updatedCustomItems.InventoryRoomID,
            RoomType: updatedCustomItems.RoomType,
            Description: updatedCustomItems.Description,
            Value: updatedCustomItems.Value,
            CurrentState: CurrentState.Modified,
            ConcurrencyCheck: updatedCustomItems.ConcurrencyCheck,
        }
        const inventoryInventoryGroups = [];
        updatedCustomItems.forEach(item => {
            const { HouseholdPersonalProperties } = item;
            if (HouseholdPersonalProperties.CurrentState === CurrentState.Modified) {
                const householdPersonalProperties = { ...HouseholdPersonalProperties };
                delete householdPersonalProperties.modified;
                item.HouseholdPersonalProperties = householdPersonalProperties;
                inventoryInventoryGroups.push(item);
            }
        });
        if (updatedCustomItems.CurrentState === CurrentState.Modified || inventoryInventoryGroups.length > 0) {
            inventoryRoom.InventoryInventoryGroups = inventoryInventoryGroups;
            dispatch(updateInventoryRoom(updatedCustomItems.InventoryID, '', { InventoryRoom: inventoryRoom }, false))
                .then(() => {
                    dispatch(updatingInventory(false));
                });
        } else {
            dispatch(updatingInventory(false));
        }
    }
}